export default __webpack_public_path__ + "assets/images/play.4f60e14d356fb124a5f0b0d6b6dd081e.svg";